import React from "react";

export default function ColorFrame41({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          stroke={fill}
          strokeLinecap="round"
          strokeWidth="3.867"
          d="M94.885 51.51H81.737L76.5 63l-11-25.5s-2.5 6-5.804 14.414H37.655M177 51.51h13.147L195.385 63l11-25.5s2.5 6 5.804 14.414h22.041M94.885 249.412H126L133 237l11.5 25.5s1.814-5.313 4.908-13.491h35.575"
        ></path>
        <path
          stroke={fill}
          strokeLinecap="round"
          strokeWidth="3.867"
          d="M97.205 249.413H84.057L79 237.5l-8.5 28s-3.5-7.5-8.484-16.491H43M176 249.009h13l5.205-11.509 8.5 28s3.5-7.5 8.484-16.491h19.016M36.166 59.656v35.575C28.5 99.5 22.574 102.5 22.574 102.5l22.426 8-9.666 6.773v17.401L43.5 140.5l-17 7 9.666 6.508v23.975L50.5 189 25 198l11.166 6.664V241M236.592 59.656v35.575C228.926 99.5 223 102.5 223 102.5l22.426 8-9.666 6.773v17.401l8.166 5.826-17 7 9.666 6.508v23.975L250.926 189l-25.5 9 11.166 6.664V241"
        ></path>
        <path
          fill={fill}
          d="M101.441 69.728c0-15.685 12.715-28.4 28.401-28.4h13.757c15.686 0 28.401 12.715 28.401 28.4a7.1 7.1 0 01-7.1 7.1h-56.359a7.1 7.1 0 01-7.1-7.1z"
        ></path>
        <mask
          id="mask0_2262_163334"
          style={{ maskType: "alpha" }}
          width="71"
          height="36"
          x="101"
          y="41"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill={fill}
            d="M101.441 69.728c0-15.685 12.715-28.4 28.401-28.4h13.757c15.686 0 28.401 12.715 28.401 28.4a7.1 7.1 0 01-7.1 7.1h-56.359a7.1 7.1 0 01-7.1-7.1z"
          ></path>
        </mask>
        <g mask="url(#mask0_2262_163334)">
          <path
            fill="#FFD1B7"
            d="M120.397 41.49c-6.849-6.532-2.226-18.077 7.237-18.077h18.683c8.922 0 13.082 11.053 6.376 16.936l-15.621 15.96-16.675-14.82z"
          ></path>
        </g>
        <path fill="#FF4440" d="M158.868 62.496H161.792V72.152H158.868z"></path>
        <path
          fill="#FF4440"
          d="M155.396 68.755H158.25699999999998V78.624H155.396z"
          transform="rotate(-90 155.396 68.755)"
        ></path>
        <path
          stroke="#3C4858"
          strokeLinecap="round"
          strokeWidth="2.728"
          d="M128.822 40.731c-3.511 0-7.61 2.547-9.127 5.23-1.518 2.681-1.898 7.44-1.614 8.827m0 0c4.582-1.299 12.952 6.097 14.17 11.855l-1.336.516m-12.834-12.371c-4.225 2.4-3.564 9.983-1.207 16.636l1.189-.33"
        ></path>
        <ellipse
          cx="149.182"
          cy="69.988"
          fill="#3C4858"
          rx="3.15"
          ry="2.923"
        ></ellipse>
        <ellipse
          cx="149.183"
          cy="69.988"
          fill="#350A72"
          rx="1.404"
          ry="1.303"
        ></ellipse>
        <path
          stroke="#3C4858"
          strokeLinecap="round"
          strokeWidth="2.728"
          d="M144.619 40.35c2.808.488 7.672 2.656 8.776 6.84 2.106 7.979-2.633 19.867-4.037 22.635"
        ></path>
        <path
          fill="#FFD1B7"
          d="M146.725 41.652c0 4.137-.379 3.42-9.478 3.42s-9.829.554-9.829-3.583c2.106-4.722.075-7.654 9.174-7.654s8.027 3.583 10.133 7.817z"
        ></path>
        <mask
          id="mask1_2262_163334"
          style={{ maskType: "alpha" }}
          width="20"
          height="13"
          x="127"
          y="33"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#FFD1B7"
            d="M146.726 41.652c0 4.137-.379 3.42-9.478 3.42-9.1 0-9.478.392-9.478-3.746 2.106-4.722-.277-7.49 8.822-7.49 9.1 0 8.027 3.582 10.134 7.816z"
          ></path>
        </mask>
        <g mask="url(#mask1_2262_163334)">
          <path
            fill="#FFD1B7"
            d="M145.321 29.764c0 4.137 1.025 14.494-8.074 14.494s-9.829-9.705-9.829-13.843c2.106-4.722.075.815 9.174.815s6.623-5.7 8.729-1.466z"
            opacity="0.5"
          ></path>
        </g>
        <path
          fill="#FFD1B7"
          d="M151.288 24.716c0 9.174-6.286 16.61-14.041 16.61-7.755 0-14.042-7.436-14.042-16.61s.527-16.61 14.042-16.61c13.164 0 14.041 7.436 14.041 16.61z"
        ></path>
        <path
          fill="#3C4858"
          d="M123.682 8.744c-5.262.492-3.921 4.518-3.266 7.486.687 3.114 1.547 2.44 2.062 5.855.359 2.376.688 3.334 1.204 2.927.21-.166.721-2.067.964-4.066.352-2.897 0-5.204.411-6.18.41-.976 1.654-2.13 5.491-.345 2.277 1.06 7.707 2.067 10.15 1.809 7.702-.814 8.435-3.578 8.938-.814.295 1.622 1.177 13.165 2.063 9.596.885-3.568 3.967-6.373 3.377-11.564-.59-5.19-3.599-.811-1.681-4.704.956-1.941 1.434-5.43.702-6.338-1.545 0-2.12 2.283-5.697 2.607-6.922.628-10.056-6.913-19.051-1.946-4.703 2.596-3.44 5.469-5.667 5.677z"
        ></path>
        <ellipse
          cx="130.578"
          cy="67.382"
          fill="#8859C2"
          rx="0.702"
          ry="0.651"
        ></ellipse>
        <ellipse
          cx="118.642"
          cy="70.964"
          fill="#8859C2"
          rx="0.702"
          ry="0.651"
        ></ellipse>
        <circle cx="36.108" cy="53.403" r="6.96" fill={fill}></circle>
        <circle
          r="6.96"
          fill={fill}
          transform="matrix(-1 0 0 1 235.777 53.403)"
        ></circle>
        <circle
          r="7.5"
          fill={fill}
          transform="matrix(1 0 0 -1 36.5 248.5)"
        ></circle>
        <circle
          r="7.5"
          fill={fill}
          transform="matrix(1 0 0 -1 236.5 248.5)"
        ></circle>
        {children}
      </g>
    </svg>
  );
}
